export default __webpack_public_path__ + "static/media/anssid.78e5463a.svg";